<div class="is-btn is-btn__outfill" [class.is-loading]="isLoading">
  <ng-container *ngIf="!isLoading">{{ label }}</ng-container>
  <ng-container *ngIf="isLoading">
    <span class="main-loader"></span>{{ 'Common.Loading' | translate }}
  </ng-container>
</div>